/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_RestartInputs */

const en_cc_restart = /** @type {(inputs: Cc_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After signing in, restart from the extension icon.`)
};

const id_cc_restart = /** @type {(inputs: Cc_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setelah masuk, mulai lagi melalui ikon ekstensi.`)
};

/**
* | output |
* | --- |
* | "After signing in, restart from the extension icon." |
*
* @param {Cc_RestartInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_restart = /** @type {((inputs?: Cc_RestartInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_RestartInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_restart(inputs)
	return en_cc_restart(inputs)
});